// 📁 ortak/src/fatura-takip/src/components/Navbar.js
import "./Navbar.css";
import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

// ✅ Doğru context yolu (ortak/src/context/AuthContext.js)
import { useAuth } from "../../../context/AuthContext";

const Navbar = () => {
  const { user, role, userPermissions, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const normalizedRole = role?.toLocaleLowerCase("tr-TR");

  // İzinleri hem fatura map'inden hem de üst düzeyden oku (fallback)
  const faturaPerm = userPermissions?.fatura || {};
  const isOwner = normalizedRole === "oluşturucu";

  const isManager =
    isOwner || !!faturaPerm.yonetici || !!userPermissions?.yonetici;

  const canTakip =
    isManager || !!faturaPerm.takip || !!userPermissions?.takip;

  const showAdmin = isOwner;

  // Kurallar:
  // - Yönetici: tüm sayfalar + Excel sayfaları
  // - Takip (yönetici değilse): tüm sayfalar - Excel sayfaları
  const showExcelPages = isManager;

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img src="/logo.png" alt="logo" className="navbar-logo" />
        <span className="navbar-title">Fatura Takip Sistemi</span>
      </div>

      {user && (
        <>
          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span></span><span></span><span></span>
          </div>

          <div className={`navbar-links ${menuOpen ? "show" : ""}`}>
            {/* Ortak sayfalar (Takip: true veya Yönetici: true) */}
            {canTakip && (
              <NavLink className="navbar-link" to="/fatura-takip/fatura-girisi">
                Fatura Girişi
              </NavLink>
            )}
            {canTakip && (
              <NavLink className="navbar-link" to="/fatura-takip/onarim-karar-destek">
                Karar Destek
              </NavLink>
            )}
            {canTakip && (
              <NavLink className="navbar-link" to="/fatura-takip/fatura-duzenle">
                Fatura Düzenle
              </NavLink>
            )}
            {canTakip && (
              <NavLink className="navbar-link" to="/fatura-takip/firma-yonetimi">
                Firma Yönetimi
              </NavLink>
            )}
            {canTakip && (
              <NavLink className="navbar-link" to="/fatura-takip/kategoriler">
                Kategori Yönetimi
              </NavLink>
            )}
            {canTakip && (
              <NavLink className="navbar-link" to="/fatura-takip/raporlar">
                Raporlar
              </NavLink>
            )}
            {canTakip && (
              <NavLink className="navbar-link" to="/fatura-takip/faturalar">
                Fatura Listesi
              </NavLink>
            )}

            {/* Excel sayfaları: sadece Yönetici */}
            {showExcelPages && (
              <NavLink className="navbar-link" to="/fatura-takip/fatura-excel-yukle">
                Excel Yükle
              </NavLink>
            )}
            {showExcelPages && (
              <NavLink className="navbar-link" to="/fatura-takip/firma-excel-yukle">
                Firma Excel Yükle
              </NavLink>
            )}
            {showExcelPages && (
              <NavLink className="navbar-link" to="/fatura-takip/kategori-excel-yukle">
                Kategori Excel Yükle
              </NavLink>
            )}

            {/* Admin: sadece global Oluşturucu */}
            {showAdmin && (
              <NavLink className="navbar-link" to="/fatura-takip/admin">
                Admin
              </NavLink>
            )}

            {/* Genel */}
            <NavLink className="navbar-link" to="/secilen-proje">🔁 Proje Seç</NavLink>
            <button className="logout-button" onClick={handleLogout}>Çıkış</button>
          </div>
        </>
      )}
    </nav>
  );
};

export default Navbar;
